/* Inkopious collection directory (Oct 2026): collection filter, site-search fallback, breed suggestions. */
(function () {
  function norm(v) { return (v || '').toLowerCase().replace(/[’'.?:&]/g, '').replace(/\s+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initFilter(root) {
    var q = root.querySelector('[data-inkdir-q]');
    if (!q) return;
    var clear = root.querySelector('[data-inkdir-clear]');
    var status = root.querySelector('[data-inkdir-status]');
    var all = root.querySelector('[data-inkdir-all]');
    var empty = root.querySelector('[data-inkdir-empty]');
    var emptyAll = root.querySelector('[data-inkdir-empty-all]');
    var groups = root.querySelectorAll('[data-inkdir-group]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var allLabel = root.getAttribute('data-all-label') || 'Search all designs for';
    var total = 0, t;

    function siteSearch(raw) { return searchUrl + '?q=' + encodeURIComponent(raw.trim()); }
    function run() {
      var raw = q.value, term = norm(raw);
      total = 0;
      clear.hidden = !term;
      groups.forEach(function (g) {
        var shown = 0;
        g.querySelectorAll('[data-inkdir-tile]').forEach(function (tile) {
          var hit = !term || norm(tile.getAttribute('data-name')).indexOf(term) > -1;
          tile.hidden = !hit;
          if (hit) shown++;
        });
        g.hidden = shown === 0;
        var chip = root.querySelector('[data-inkdir-chip="' + g.getAttribute('data-inkdir-group') + '"]');
        if (chip) chip.hidden = shown === 0;
        total += shown;
      });
      empty.hidden = total > 0;
      status.textContent = term ? (total === 1 ? '1 collection found.' : total + ' collections found.') : '';
      if (term) {
        var label = allLabel + ' “' + raw.trim() + '”';
        all.href = siteSearch(raw); all.textContent = label; all.hidden = total === 0;
        emptyAll.href = siteSearch(raw); emptyAll.textContent = label;
      } else {
        all.hidden = true;
      }
    }
    q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 80); });
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(); if (total === 0 && norm(q.value)) window.location.href = siteSearch(q.value); }
    });
    clear.addEventListener('click', function () { q.value = ''; run(); q.focus(); });

    var header = document.querySelector('.header-section, #header, .header');
    if (header && window.getComputedStyle(header).position === 'sticky') {
      root.style.setProperty('--inkdir-sticky', header.offsetHeight + 'px');
    }
  }

  function initBreeds(root) {
    var band = root.querySelector('[data-inkdir-breed]');
    if (!band) return;
    var bq = band.querySelector('[data-inkdir-bq]');
    var list = band.querySelector('[data-inkdir-br]');
    var fallback = band.getAttribute('data-fallback');
    var data = [];
    try { data = JSON.parse(band.querySelector('[data-inkdir-breeds]').textContent); } catch (e) {}
    data.forEach(function (b) { b.n = norm(b.t); });
    var matches = [];
    function close() { list.hidden = true; bq.setAttribute('aria-expanded', 'false'); }
    function byLen(x, y) { return x.n.length - y.n.length; }
    function find() {
      var term = norm(bq.value);
      if (!term) { matches = []; close(); return; }
      var a = [], w = [], c = [];
      data.forEach(function (b) {
        var i = b.n.indexOf(term);
        if (i === 0) a.push(b); else if (b.n.indexOf(' ' + term) > -1) w.push(b); else if (i > -1) c.push(b);
      });
      matches = a.sort(byLen).concat(w.sort(byLen), c.sort(byLen)).slice(0, 8);
      list.innerHTML = matches.length
        ? matches.map(function (b) { return '<li><a href="' + esc(b.u) + '">' + esc(b.t) + '</a></li>'; }).join('')
        : '<li class="is-none">No match. <a class="is-inline" href="' + esc(fallback) + '">See all breeds</a></li>';
      list.hidden = false;
      bq.setAttribute('aria-expanded', 'true');
    }
    bq.addEventListener('input', find);
    bq.addEventListener('focus', function () { if (bq.value) find(); });
    bq.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); window.location.href = matches.length ? matches[0].u : fallback; }
      else if (e.key === 'ArrowDown') { var first = list.querySelector('a'); if (first && !list.hidden) { e.preventDefault(); first.focus(); } }
      else if (e.key === 'Escape') { close(); }
    });
    list.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(list.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : bq).focus(); }
      else if (e.key === 'Escape') { close(); bq.focus(); }
    });
    document.addEventListener('click', function (e) { if (!band.contains(e.target)) close(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-inkdir]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      initFilter(root);
      initBreeds(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();